export default __webpack_public_path__ + "static/media/island_7_with_objects.c733c9b4.png";